import { useCallback, useEffect, useState } from 'react';

const TOOLTIP_DELAY = 5000;

interface UseShowTooltipProps {
  clickHandler?: () => void;
  interval?: number;
}

export const useShowTooltip = ({ clickHandler, interval = TOOLTIP_DELAY }: UseShowTooltipProps) => {
  const [isVisible, setSetVisible] = useState(false);

  const onTooltipTriggerClick = useCallback(() => {
    setSetVisible(true);

    if (clickHandler) {
      clickHandler();
    }
  }, [clickHandler]);

  const hideTooltip = useCallback(() => {
    setSetVisible(false);
  }, []);

  useEffect(() => {
    if (!isVisible) {
      return;
    }

    const visibilityInterval = setTimeout(() => setSetVisible(false), interval);

    return () => {
      clearTimeout(visibilityInterval);
    };
  }, [isVisible]);

  return { isVisible, onTooltipTriggerClick, hideTooltip };
};
